/* eslint-disable react/jsx-one-expression-per-line */
import React, {Component} from 'react';
import IconFont from 'Components/common/iconFont';
import VoiceGrey from 'Static/images/sound-grey.gif';
import VoiceWhite from 'Static/images/sound-white.gif';

import './index.less';

class SegmentedSpeech extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isPlaying: false,
    };
    this.audio = null;
  }

  componentDidMount() {
    const {isPlay} = this.props;
    this.audio.addEventListener('timeupdate', this.timeupdate, false);

    if (isPlay) {
      this.toggle(true);
    }
  }

  componentWillReceiveProps(nextProps) {
    const {isPlay} = this.props;

    if (nextProps.isPlay !== isPlay) {
      this.toggle(nextProps.isPlay);
    }
  }

  componentWillUnmount() {
    this.audio.removeEventListener('timeupdate', this.timeupdate, false);
  }

  timeupdate = () => {
    const {end} = this.props;

    if (this.audio.currentTime - end / 1000 > 0) {
      this.toggle(false);
    }
  };

  toggle = isPlay => {
    const {
      audio,
      props: {start = 0, replay = true, onChange = () => {}},
    } = this;

    if (isPlay && replay) {
      audio.currentTime = start / 1000;
    }

    this.setState(
      {
        isPlaying: isPlay,
      },
      () => {
        audio[isPlay ? 'play' : 'pause']();
        onChange(isPlay);
      },
    );
  };

  onClick = () => {
    const {isPlaying} = this.state;

    this.toggle(!isPlaying);
  };

  render() {
    const {source, speaker, start, end} = this.props;
    const {isPlaying} = this.state;

    return (
      <div className="audio">
        {/* 音频播放器 */}
        <audio
          src={source}
          controls="controls"
          ref={ref => {
            this.audio = ref;
          }}>
          Your browser does not support the audio element.
        </audio>

        <div
          className={`audio-play is-${speaker ? 'right' : 'left'}`}
          onClick={this.onClick}>
          <div className="audio-icon">
            {isPlaying ? (
              <img alt="" src={speaker ? VoiceGrey : VoiceWhite} />
            ) : (
              <IconFont
                type={speaker ? 'icon-robotsounds-right' : 'icon-robotsounds'}
              />
            )}
          </div>
          <div className="audio-time">
            {`${
              end && (start || start === 0)
                ? Math.round((end - start) / 1000)
                : 0
            }''`}
          </div>
        </div>
      </div>
    );
  }
}
export default SegmentedSpeech;
